import ViewFactory from "../../../helpers/viewfactory";
import { USSD_CODE_REGEX } from "../../../../../utils/regex";
import { traverseDataFields } from "../../../../../charge/handler/helpers";
import { getValueAtPath, isPlainObject, isString, toArray } from "../../../../../utils";
import ProcessingState from "../../../../common/processing";
import SuccessView from "../../../common/success";

export function onRequireValidation() {
  const $this = this;
  const { $inputs, $charge, dispatch } = this;

  return function __onRequireValidation__() {
    const accountbank = getValueAtPath($inputs, '[bank].value.code') || null;

    if (accountbank === '232') {
      dispatch(ProcessingState.actions.on());

      setTimeout(() => {
        const pollConfig = {
          onCancel() { pollConfig.onComplete() },
          onFailure(data) { /* self.console.log(data) */ },
          onSuccessful() { SuccessView && SuccessView.activate.call($this) },
          onComplete() { /* self.console.log({ ...$this }) */ }
        };

        $charge.poll(pollConfig);
      }, 10 * 1000);

      return;
    }

    const { validateInstruction } = traverseDataFields(this.data, 'validateInstruction');
    const { validateInstructions } = traverseDataFields(this.data, 'validateInstructions');

    if (isPlainObject(validateInstructions)) {
      let { valparams } = validateInstructions;
      valparams = toArray(valparams);

      if (valparams.length === 1 && String(valparams[0]).toUpperCase().indexOf('OTP') >= 0) {
        $this.VALIDATE_INSTRUCTION = getValueAtPath(validateInstructions, 'instruction') || '';

        if (['044', '101'].indexOf(accountbank) >= 0) {
          const [, dialCode] = String(validateInstruction).match(USSD_CODE_REGEX) || [];

          if (dialCode) {
            let accno = getValueAtPath($inputs, '[account_number].value') || null;

            accno = isString(accno)
              ? accno.replace(/^(\d{3})(\d+?)(\d{4})$/, (_, $1, $2, $3) => `${$1}${$2.replace(/./g, '*')}${$3}`)
              : 'your account';

            $this.VALIDATE_INSTRUCTION = `Dial ${dialCode} on the mobile number registered with ${accno} to get your OTP.`;
          }
        }

        $this.SHOULD_VALIDATE_CHARGE = false;
        $this.SHOULD_VALIDATE_CHARGE = true;
      }
    }
  }
}

export function chargeBankAccount() {
  const $this = this;
  const { DATA, $charge, $inputs } = this;

  const currency = getValueAtPath(DATA, 'currency') || 'NGN';

  switch (currency) {
    case 'EUR':
    case 'GBP': {
      // const address = getValueAtPath($inputs, '[address].value') || null;
      // const city = getValueAtPath($inputs, '[city].value') || null;
      // const state = getValueAtPath($inputs, '[state].value') || null;
      // const postalcode = getValueAtPath($inputs, '[postal_code].value') || null;

      let phonenumber = getValueAtPath($this.DATA, 'phone');
      const redirectUrl = getValueAtPath($this.DATA, 'redirect_url');

     // `is_token_io: 1` used to be sent here; the backend now derives the PWB
     // provider from payment_type, so it is intentionally omitted.
     let data =  {
       payment_type: "account-ach-uk",
     }


     if (currency === 'EUR' || currency === 'GBP') {
       const countryCode = $inputs?.country?.value?.code || getValueAtPath($inputs, '[country].value.code') || null;
       if (countryCode) {
         data['billing_country'] = countryCode;
       }
     }


     if (phonenumber) {
       data['phonenumber'] = phonenumber;
     }


      data['redirect_url'] = redirectUrl !== null ? redirectUrl : '#checkout:no_json_render';
      $charge.init({
        data
      });

      break;
    }

    case 'NGN': {
      // const bvn = getValueAtPath($inputs, '[account_bvn].value') || null;
      // const otp = getValueAtPath($inputs, '[account_otp].value') || null;
      // const passcode = getValueAtPath($inputs, '[account_dob].value') || null;
      // const accountbank = getValueAtPath($inputs, '[bank].value.code') || null;
      // const accountnumber = getValueAtPath($inputs, '[account_number].value') || null;
      // const phonenumber = getValueAtPath($inputs, '[account_phone].value') || null;

      const data = {
        payment_type: 'account',
        // accountbank: accountbank,
        // accountnumber: accountnumber || '00000',
        // phonenumber: phonenumber || getValueAtPath($this.DATA, 'phone')
        phonenumber: getValueAtPath($this.DATA, 'phone'),
        is_mono: true
      };

      // bvn && (data['bvn'] = bvn);
      // otp && (data['otp'] = otp);
      // passcode && (data['passcode'] = passcode);

      // const currentCanResendOTP = Boolean($this.CAN_RESEND_OTP);

      const restoreCanResendOTP = () => setTimeout(() => {
        // $this.CAN_RESEND_OTP = currentCanResendOTP;
        // $inputs.$reset();
        view && view.activate.call($this);
      }, 0);

      $this.CAN_RESEND_OTP = false;

      $charge.init({
        data,
        onError: restoreCanResendOTP,
        onFailed: restoreCanResendOTP,
        onRequireValidation: onRequireValidation.call($this)
      });

      break;
    }

    case 'USD': {
      $charge.init({
        data: {
          country: 'US',
          is_us_bank_charge3: true,
          ach_redirect_url: new URL('/usach/complete').href
        }
      });

      break;
    }

    case 'ZAR': {
      const sabankcode = getValueAtPath($inputs, '[sa_bank].value.code');
      const customer_identifier = getValueAtPath($inputs, '[customer_identifier].value') || null;
      const zarData = { sabankcode, country: 'ZA', is_sa_call_pay: true };
      if (customer_identifier) zarData.customer_identifier = customer_identifier;
      $charge.init({ data: zarData });

      break;
    }
  }
}

export default function view() {
  const $this = this;
  // const { DATA, $inputs } = this;

  return (view = ViewFactory({
    NAME: 'BANK_INIT_VIEW',
    mutables: { isHighRisk: 'IS_HIGH_RISK' },
    inputs: ['sa_bank', 'country', 'customer_identifier'],
    // inputs: [
    //   'account_bvn', 'account_dob', 'account_number', 'account_phone', 'account_otp',
    //   'address', 'bank', 'city', 'postal_code', 'state'
    // ],
    // inputs: ['address', 'city', 'postal_code', 'state'],
    next() { return chargeBankAccount.call($this) },
    // back() {
    //   // const currency = getValueAtPath(DATA, 'currency') || 'NGN';
    //   // currency === 'NGN' && $inputs.$reset();
    // }
    afterSetup() { $this._subscribeInputsOnce() },
  }).call(this));
}
